import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { PositionProvider } from "../../../context/PositionContext";

export const Attractions = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddAttraction = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditAttraction = () => {
  return (
    
      
        <Edit />
      
    
  );
};

export const ViewAttraction = () => {
  return (
    
      <Detail />
    
  );
};
